import { call, put, delay } from 'redux-saga/effects'
import { push } from 'connected-react-router'
import FirmsActions from '../Redux/FirmsRedux'
import AuthActions from '../Redux/AuthRedux'
import ErrorsActions from '../Redux/ErrorsRedux'

export function * getFirms(api, authApi, { page, page_size, sort_field, sort_order, search, filter }) {
  try {
    const response = yield call(api.getFirms, page, page_size, sort_field, sort_order, search, filter);
    if (response && response.ok) {
      yield put(FirmsActions.firmsSuccess(response.data))
    } else  {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave("Server response error"))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave(response?.originalError?.message || "INTERNET DISCONNECTED"))
      }
      yield put(FirmsActions.firmFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh);
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh));
        yield * getFirms(api, authApi, { page, page_size, sort_field, sort_order, search, filter });
      } else {
        yield put(AuthActions.logout());
        yield put(push('/login'))
      }
    }

  } catch(e) {
    yield put(FirmsActions.firmFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: '+e))
  }
}

export function * getFirm(api, authApi, { firmId }) {
  try {
    const response = yield call(api.getFirm, firmId);
    if (response && response.ok) {
      yield put(FirmsActions.firmSuccess(response.data))
    } else  {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave("Server response error"))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave(response?.originalError?.message || "INTERNET DISCONNECTED"))
      }
      yield put(FirmsActions.firmFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh);
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh));
        yield * getFirm(api, authApi, { firmId });
      } else {
        yield put(AuthActions.logout());
        yield put(push('/login'))
      }
    }

  } catch(e) {
    yield put(FirmsActions.firmFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: '+e))
  }
}

export function * deleteFirm(api, authApi, { id }) {
  try {
    const response = yield call(api.deleteFirm, id);
    if (response && response.ok) {
      yield put(FirmsActions.firmDeleteSuccess(response.data ? response.data : true));
      yield put(FirmsActions.firmDeleteReset())
      yield put(push(`/home/investment-firms`))
    } else  {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave("Server response error"))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave(response?.originalError?.message || "INTERNET DISCONNECTED"))
      }
      yield put(FirmsActions.firmFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh);
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh));
        yield * deleteFirm(api, authApi, { id });
      } else {
        yield put(AuthActions.logout());
        yield put(push('/login'))
      }
    }
  } catch(e) {
    yield put(FirmsActions.firmFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: '+e))
  }
}

export function * saveFirm(api, authApi, { data }) {
  try {
    const saveFunc = data.id ? api.updateFirm : api.addFirm;
    const response = yield call(saveFunc, data);
    if (response && response.ok) {
      yield put(FirmsActions.firmsRequest())
      yield delay(500)
      yield put(FirmsActions.firmSaveSuccess(response.data))
      yield put(FirmsActions.firmSaveReset())

    } else  {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave("Server response error"))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave(response?.originalError?.message || "INTERNET DISCONNECTED"))
      }
      yield put(FirmsActions.firmFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh);
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh));
        yield * saveFirm(api, authApi, { data });
      } else {
        yield put(AuthActions.logout());
        yield put(push('/login'))
      }
    }
  } catch(e) {
    yield put(FirmsActions.firmFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: '+e))
  }
}
